import { DynamicIcon, iconNames } from "lucide-react/dynamic";

const VALID = new Set(iconNames);

function toKebab(name) {
  if (!name) return "square";
  const k = String(name)
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .toLowerCase();
  return VALID.has(k) ? k : "square";
}

export function Icon({ name, className = "", ...props }) {
  return <DynamicIcon name={toKebab(name)} className={className} {...props} />;
}
